export const appConfig = {
  region: 'ap-northeast-1',
  identityPoolId: 'ap-northeast-1:3be3d94c-2f3a-4acd-8966-2e14423988ce',
  userPoolId: 'ap-northeast-1_b8ht1zLgK',
  userPoolWebClientId: '5sada3svlkaj0u5b9fp8d9h9cr',
  apiUrl: 'https://develop.jp.test.ml.vgs-dxone.com',
  wssUrl: 'wss://develop.jp.test.ml.vgs-dxone.com/wss',
};
